import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/button/button'
import {Popup} from '@components/common/popup/popup'
import {LinkAsButton} from '@components/sticker/my-stickers/common/add-link/add-link'
import {ChangesHistoryHint} from './changes-history-hint'
import {CustomCKEditor} from './ck-editor'
import {TwHistoryFooter, TwHistoryLeftSideContainer} from './containers'
import {EditorHistoryContainer} from './editor-history-container'
import {EmptyHistory} from './empty-history'
import {TaskDescriptionHistoryList} from './task-description-history-list'
import {useTaskDescription} from './task-description-store'

export const TaskDescriptionHistoryWrapper = observer(() => {
  const [state] = useTaskDescription()
  if (!state.historyMode) {
    return null
  }

  return <TaskDescriptionHistory />
})

const TwSplitter = tw.div`
  border-0
  border-b-1
  border-split-old
  border-solid
  w-full
`

export const TaskDescriptionHistory = observer(() => {
  const [state, store] = useTaskDescription()

  useEffect(() => {
    void store.loadHistory()
  }, [store.taskHub?.id])

  useEffect(() => {
    void store.loadHistoryContent()
  }, [store.taskHub?.id, state.selectedHistoryAt])

  const onClose = () => store.setHistoryMode(false)
  const onSubmit = () => store.saveHistory()

  const content = state.historyContent || ''
  const showContent = !!(content || state.historyList?.length)

  return (
    <Popup
      className="z-2000"
      width={960}
      close={onClose}
      title={Lang.msg.changesHistory}
      contentClassName={'p-0 flex'}
      minHeightAuto
    >
      <TwHistoryLeftSideContainer id="desc-history-editor">
        {showContent && (
          <>
            <EditorHistoryContainer>
              <CustomCKEditor readonly value={content} kindOf="task-history" />
            </EditorHistoryContainer>
            <TwSplitter />
            <TwHistoryFooter>
              <ChangesHistoryHint />
              <LinkAsButton onClick={onClose}>{Lang.msg.cancel}</LinkAsButton>
              <Button onClick={onSubmit}>
                {Lang.msg.changesHistorySubmit}
              </Button>
            </TwHistoryFooter>
          </>
        )}
        {!showContent && <EmptyHistory />}
      </TwHistoryLeftSideContainer>

      <TaskDescriptionHistoryList />
    </Popup>
  )
})
